export default __webpack_public_path__ + "static/media/recent-ebin.affd83b1.png";